import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react'; // Import PersistGate
import { ConfigProvider } from 'antd';
import antdTheme from './theme/antdTheme';

import { Provider } from 'react-redux';
import {store, persistor} from './store';

const userRole=localStorage.getItem('userRole')
const app = (
    <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider theme={antdTheme}>
          <BrowserRouter>
              <App userRole={userRole}/>
          </BrowserRouter>
        </ConfigProvider>
        </PersistGate>
    </Provider>
);


createRoot(document.getElementById('root')).render(app);
